const ActionLangTypes = {
  CHANGE_LANGIAGE: "CHANGE_LANGIAGE",
};

export default ActionLangTypes;
